import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "Docs-Page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MDXProvider = _resolveComponent("MDXProvider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.componentGenerator)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MDXProvider, { components: _ctx.MDX_COMPONENTS }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentGenerator)))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["components"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, "no page matches this url"))
  ]))
}